/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

$(document).ready(function () {
    /**
     * Plugins
     * */

    /**
     * Modules
     **/
    // require('./modules/story/changeStageStatus')

    /**
     * Components
     * */
    require('./components/side-panels/transaction-invoices-selector')
    require('./components/side-panels/invoiceables-selector')
    require('./components/side-panels/invoices-selector')
    require('./components/invoices/row-grouping')
});
